import Location from "../../../../models/state/locations/location/Location";

export const getId = (state: Location) => state.id;

export const getName = (state: Location) => state.name;

export const getCountryName = (state: Location) => state.countryName;

export const getImageUrl = (state: Location) => state.imageURL;

export const getLatitude = (state: Location) => state.latitude;

export const getLongitude = (state: Location) => state.longitude;
